import { render } from "./ReportsPage.vue?vue&type=template&id=0e4b4730&scoped=true"
import script from "./ReportsPage.vue?vue&type=script&lang=js"
export * from "./ReportsPage.vue?vue&type=script&lang=js"

import "./ReportsPage.vue?vue&type=style&index=0&id=0e4b4730&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4b4730"]])

export default __exports__